import { useEffect, useState } from 'react';
import { auth } from './api.js';

/**
 * The signed-in owner.
 *
 * Extracted from the layout so the messenger and the settings screens can each
 * decide their own chrome without duplicating the session check.
 */

export interface OwnerSession {
  ownerId: string;
  email: string;
  limits: { maxActiveConversations: number; maxInvitesPerDay: number; maxUploadBytes: number };
}

export type SessionState = 'loading' | 'ready' | 'signed-out' | 'suspended';

export function useOwnerSession() {
  const [owner, setOwner] = useState<OwnerSession | null>(null);
  const [state, setState] = useState<SessionState>('loading');
  const [suspensionReason, setSuspensionReason] = useState<string | null>(null);

  useEffect(() => {
    auth
      .session()
      .then((session) => {
        if (session.owner.suspendedAt) {
          setSuspensionReason(session.owner.suspensionReason);
          setState('suspended');
          return;
        }
        setOwner({ ownerId: session.owner.id, email: session.owner.email, limits: session.limits });
        setState('ready');
      })
      .catch(() => setState('signed-out'));
  }, []);

  return { owner, state, suspensionReason };
}
